import React, { useState, useEffect } from "react";
import CheckBox from "devextreme-react/check-box";
import { FiAlertTriangle, FiInfo } from "react-icons/fi";
import { Tooltip } from "devextreme-react/tooltip";

export default function GroupTemplate({
  isProjectConfirmed,
  checked: _checked,
  onValueChanged,
  groupText,
  hasNoSenior,
}) {
  const [checked, setChecked] = useState(_checked);

  useEffect(() => {
    setChecked(_checked);
  }, [_checked]);

  return (
    <div>
      <React.Fragment>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <CheckBox
            value={checked}
            onValueChanged={onValueChanged}
            visible="true"
          />
          <span style={{ marginLeft: "5px" }}> {groupText} </span>
          {hasNoSenior && (
            <span style={{ marginLeft: "5px" }}>
              <Tooltip
                target=".danger-icon"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                position="top"
              >
                This project has no seniors to evaluate you. Please, click here
                to contact HR for more information
              </Tooltip>
              <a
                href="mailto:hrglobal@integrationconsulting.com"
                //title="Click here to contact PDC via Outlook"
              >
                <FiAlertTriangle
                  fill="yellow"
                  color="black"
                  className="danger-icon"
                  style={{
                    fill: "yellow",
                    marginLeft: "5px",
                    cursor: "pointer",
                  }}
                />
              </a>
            </span>
          )}
        </div>
      </React.Fragment>
    </div>
  );
}
